import * as React from 'react'
import styled from 'styled-components'

interface Props {
  children: any
  error?: boolean
  style?: any
  visible?: boolean
}

export const FeedbackText = (props: Props) => {
  const { children, error, style, visible } = props
  return (
    <StyledText error={error} show={visible && !!children} style={style}>
      {error ? (
        <i className='far fa-times-circle' />
      ) : (
        <i className='far fa-check-circle' />
      )}{' '}
      {children}
    </StyledText>
  )
}

const StyledText = styled.p`
  display: ${(props) => (props.show ? 'block' : 'none')};
  margin: 15px 30px 30px 30px;
  font-size: 16px;
  text-align: center;
  color: ${(props) => (props.error ? 'red' : '#62d760')};
`
StyledText.defaultProps = {
  error: false
}

export default FeedbackText



// WEBPACK FOOTER //
// ./src/components/atoms/FeedbackText.tsx